module.exports = __webpack_public_path__ + "img/tutorial_img_1_1.62828a92.png";